'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-undef: "off" */
/**
 * search panel
 */
define('searchPanel',['busEvent', 'jquery', 'util', 'searchSortApi', 'GAReport', 'xparkProductCard', 'svgIcon'], function (busEvent, $, Util, searchSortApi, GAReport, xparkProductCard, svgIcon) {
  return {
    template: '\n      <div class="in-search-container">\n        <transition name="fade">\n          <div class="in-search-panel" v-if="isPageShow">\n            <div class="in-search-nav">\n              <button type="button" class="in-search-back" @click="hideSearchPanel" aria-label="Back">\n                <svg-icon type="arrowLeft"></svg-icon>\n              </button>\n              <form class="in-navbar-form in-search-nav-form" @submit.prevent="submit">\n                <input ref="searchInput" v-model.trim="keyWords" class="in-navbar-search-box" :placeholder="i18n.searchPlaceholder" />\n              </form>\n              <button type="button" class="in-search-submit" @click="submit" v-text="i18n.searchAction"></button>\n            </div>\n            <div class="in-search-wrapper">\n              <div class="in-search-box" ref="searchBox">\n\n                <div v-if="showHotWords" class="in-hot-words-area">\n                  <p class="in-hot-words-title">\n                    <i class="xp-iconfont xp-icon-hot-tag"></i>\n                    <span v-text="i18n.hotWords"></span>\n                  </p>\n                  <ul class="in-hot-words">\n                    <li v-for="word in hotWords">\n                      <a target="_blank" :href="\'/catalogsearch/result/?q=\' + word" @click="onSearchWordClicked(\'hot\', word)" v-text="word"></a>\n                    </li>\n                  </ul>\n                </div>\n\n                <div class="xp-product-grid in-search-product-grid" v-if="productList.length">\n                  <xpark-product-card\n                    v-for="(item, index) in productList.slice(0, 3)"\n                    :key="(item.product_id || item.id || item.sku || item.name) + \'-\' + index"\n                    :product="item"\n                  ></xpark-product-card>\n                </div>\n              </div>\n\n              <div v-show="!showHotWords && productList.length <= 0 && requestComplete" class="search-empty-wrap">\n                <img :src="require.toUrl(\'images/search-empty.svg\')" >\n                <div class="search-empty-text" v-text="i18n.emptyText"></div>\n              </div>\n            </div>\n          </div>\n        </transition>\n      </div>\n    ',
    data: function data() {
      return {
        isPageShow: false,
        showHotWords: true,
        logo: {},
        i18n: {
          searchPlaceholder: 'Try to search for Note 60 Pro',
          searchAction: 'Search',
          hotWords: 'Hot Search',
          emptyText: 'Sorry, no result is found.'
        },
        keyWords: '',
        page: 1,
        pageSize: 4,
        productList: [],
        hotWords: [],
        requestComplete: false
      };
    },

    components: {
      xparkProductCard: xparkProductCard,
      svgIcon: svgIcon
    },
    mounted: function mounted() {
      this.init();
      this.onEnter();
    },

    watch: {
      keyWords: function keyWords(newKw, oldKw) {
        if (newKw) {
          this.showHotWords = false;
          this.getKeyWords();
        } else {
          this.showHotWords = true;
        }
      }
    },
    methods: {
      init: function init() {
        this.onShowEvent();
        var defaultHotWords = ['Note 60 Pro', 'ZERO Flip', 'Xbuds NC-XE28', 'GT Buds', 'GT 30 Pro', 'Value Bundle'];
        this.hotWords = window.commonDataJSON && window.commonDataJSON.trending_search_kws && window.commonDataJSON.trending_search_kws.length ? [].concat(_toConsumableArray(window.commonDataJSON.trending_search_kws)) : defaultHotWords;
      },
      onShowEvent: function onShowEvent() {
        var _this = this;

        busEvent.$on('showSearchEvent', function () {
          _this.isPageShow = true;
          setTimeout(function () {
            $('.in-search-panel input').focus();
          }, 100);
        });
      },
      hideSearchPanel: function hideSearchPanel() {
        this.isPageShow = false;
        this.showHotWords = true;
        this.productList = [];
        this.keyWords = '';
        busEvent.$emit('closeSearchEvent');
      },
      onEnter: function onEnter() {
        // let self = this
        // $(window).keydown(function (event) {
        //   switch (event.keyCode) {
        //     case 13:
        //       self.submit()
        //       break
        //     case 27:
        //       self.hideSearchPanel()
        //       break
        //     default:
        //   }
        // })
      },
      submit: function submit() {
        if (this.keyWords) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'Search',
            nonInteraction: false,
            eventCategory: 'Header Menu',
            eventAction: 'Search',
            eventLabel: 'Search:' + this.keyWords
          });

          new GAReport().customerClick({
            eventAction: this.keyWords,
            eventCategory: 'SEARCH_KEY_#VERSION#'
          });

          Util.redirect('/catalogsearch/result/?q=' + this.keyWords);
        }
      },

      /**
       * 获取预搜索列表
       */
      getKeyWords: Util.debounce(function () {
        var _this2 = this;

        // 输入搜索词事件
        new GAReport().searchData({
          searchTerm: this.keyWords
        });

        searchSortApi({
          kws: this.keyWords,
          page: this.page,
          pageSize: this.pageSize
        }).then(function (resData) {
          _this2.requestComplete = true;
          if (resData.items.length > 0) {
            _this2.productList = resData.items;
          } else {
            _this2.productList = [];
          }
          var offset = (_this2.page - 1) * _this2.pageSize;
          var productList = (_this2.productList || []).map(function (item, index) {
            return {
              'name': item.name, // Name or ID is required.
              'id': item.sku || "",
              'price': item.final_price,
              'brand': item.brand || "",
              'category': item.category || "",
              'variant': "",
              'list': 'SEARCH_ ' + _this2.keyWords,
              'position': offset + index + 1
            };
          });
          new GAReport().productExposure({
            'eventAction': 'HOME_SEARCH_SUGFESTION',
            'eventCategory': 'HOME_PRODUCT_EXPOSURE_#VERSION#',
            'productList': productList
          });
          _this2.requestComplete = true;
        });
      }, 500),

      // 推荐词和热词点击
      onSearchWordClicked: function onSearchWordClicked(type, text) {
        if (type === "history") {
          new GAReport().customerClick({
            eventAction: text,
            eventCategory: 'SEARCH_HISTORY_#VERSION#'
          });
        } else if (type === "hot") {
          new GAReport().customerClick({
            eventAction: text,
            eventCategory: 'SEARCH_RECOMMEND_#VERSION#'
          });
        }
      }
    }
  };
});
